export default __webpack_public_path__ + "static/media/infocycle-min.84d40260.png";